import { addMessages } from '@hana/i18n';

// Khoá chuỗi của tab Nhập & đồng bộ (ImpTab.tsx). Dữ liệu mẫu của board (tên nguồn, ghi chú, tàu, service) và mã hãng không dịch.
addMessages('vi', {
  'ip.kVes': 'Đổi tàu',
  'ip.kEtd': 'Đổi ETD',
  'ip.kCls': 'Đổi closing',
  'ip.kDly': 'Trễ',
  'ip.iNew': 'Mới',
  'ip.iDup': 'Trùng',
  'ip.iUnk': 'Chưa khớp',
  'ip.sOk': 'Chạy tốt',
  'ip.sLate': 'Trễ lịch chạy',
  'ip.sErr': 'Lỗi lần chạy cuối',
  'impt.noWrite': 'Chưa bật ghi Services Map',
  'ip.wait': 'Chờ duyệt',
  'ip.waitSub': 'chênh lệch lớn hơn 1 ngày, đổi tàu, đổi closing, trễ',
  'ip.autoToday': 'Đã tự ghi hôm nay',
  'ip.autoSub': 'ETD lệch ≤ 1 ngày · có Hoàn tác',
  'ip.srcErr': 'Nguồn lỗi',
  'ip.allGood': 'mọi nguồn đang bật chạy tốt',
  'ip.hplDown': 'Lịch hãng HPL không phản hồi 06:00',
  'ip.allOk': 'Mọi nguồn chạy tốt',
  'ip.dueSvc': 'Service sắp hết lịch',
  'ip.dueSub': 'còn ≤ 6 tuần lịch dài hạn · cần nhập file hãng',
  'impt.all': 'Tất cả',
  'ip.autoTip': 'Lệch 1 ngày · tự ghi {at} · nguồn {src}',
  'ip.autoDone': 'Đã tự ghi',
  'ip.sync': 'Nguồn đồng bộ',
  'ip.rows7': 'Dòng cập nhật 7 ngày',
  'ip.lastSync': 'Lần đồng bộ cuối {at}',
  'ip.syncNow': 'Đồng bộ ngay',
  'ip.off': 'Đang tắt',
  'ip.enable': 'Bật đồng bộ {v}',
  'ip.offLast': 'Đang tắt · lần cuối {v}',
  'ip.spark': '{k}: {n} dòng cập nhật trong 7 ngày ({h})',
  'ip.import': 'Nhập file hãng',
  'ip.importTip': 'Excel · CSV · ZIP nhiều file · PDF / ảnh qua Ask HANA · tự khớp service theo hãng + tên service',
  'ip.carrierSel': 'Hãng: {v}',
  'ip.carrier': 'Hãng',
  'ip.aiTip': 'Ask HANA đọc ảnh / PDF Routing Network, Long Term Schedule · chỉ điền nháp',
  'ip.aiBtn': 'Ask HANA đọc ảnh / PDF',
  'ip.pickFile': 'Chọn file lịch hãng',
  'ip.rowsN': '{n} dòng',
  'ip.byKind': 'Lọc theo loại thay đổi',
  'ip.draft': 'Bản nháp · {v}',
  'ip.preview': 'Dòng xem trước',
  'ip.pickWrite': 'Chọn ghi {v}',
  'ip.cancel': 'Huỷ',
  'ip.confirm': 'Xác nhận ghi {n} chuyến',
  'ip.recon': 'Đối chiếu thực tế ↔ lịch dài hạn',
  'ip.reconSrc': 'Nguồn: thông báo hãng · API hãng · TblVesselData',
  'ip.reconFilter': 'Lọc đối chiếu',
  'ip.autoRule': 'ETD lệch ≤ 1 ngày: tự ghi vào lịch dài hạn, có nhật ký và Hoàn tác · lệch hơn 1 ngày, đổi tàu, đổi closing: chờ Pricing duyệt',
  'ip.autoLabel': 'Tự ghi lệch ≤ 1 ngày',
  'ip.autoAria': 'Tự ghi chênh lệch nhỏ',
  'ip.autoOff': 'Tự ghi đang tắt · mọi chênh lệch chờ duyệt',
  'ip.noDiff': 'Không còn chênh lệch',
  'ip.diffs': 'Chênh lệch lịch',
  'ip.change': '{f} {a} thành {b}',
  'ip.undoAria': 'Hoàn tác tự ghi {v}',
  'ip.undo': 'Hoàn tác',
  'ip.skipAria': 'Bỏ qua chênh lệch {v}',
  'ip.skip': 'Bỏ',
  'ip.notify': 'Báo Booking',
  'ip.approve': 'Duyệt',
  'ip.due': 'Sắp hết lịch',
  'ip.ended': 'Hết lịch',
  'ip.soon': 'Sắp hết',
  'ip.allCovered': 'Mọi service đủ lịch',
  'ip.endedAfter': 'Hết lịch sau {v}',
  'ip.until': 'Lịch đến {v}',
  'ip.openSvc': 'Mở service {v}',
  'ip.weeksLeft': '{c}: còn {n} tuần lịch dài hạn · đến {v}',
  'ip.weeks': '{n} tuần',
  'ip.importFor': 'Nhập lịch {a} cho {b}',
  'ip.recent': 'Lần nhập gần đây',
});
addMessages('en', {
  'ip.kVes': 'Vessel change',
  'ip.kEtd': 'ETD change',
  'ip.kCls': 'Closing change',
  'ip.kDly': 'Delay',
  'ip.iNew': 'New',
  'ip.iDup': 'Duplicate',
  'ip.iUnk': 'Unmatched',
  'ip.sOk': 'Running well',
  'ip.sLate': 'Run overdue',
  'ip.sErr': 'Last run failed',
  'impt.noWrite': 'Writing Services Map is not enabled',
  'ip.wait': 'Pending approval',
  'ip.waitSub': 'difference over 1 day, vessel change, closing change, delay',
  'ip.autoToday': 'Auto-written today',
  'ip.autoSub': 'ETD off by ≤ 1 day · can be undone',
  'ip.srcErr': 'Failing sources',
  'ip.allGood': 'all enabled sources are running well',
  'ip.hplDown': 'HPL carrier schedule did not respond at 06:00',
  'ip.allOk': 'All sources running well',
  'ip.dueSvc': 'Services running out of schedule',
  'ip.dueSub': '≤ 6 weeks of long-term schedule left · carrier file needed',
  'impt.all': 'All',
  'ip.autoTip': 'Off by 1 day · auto-written {at} · source {src}',
  'ip.autoDone': 'Auto-written',
  'ip.sync': 'Sync sources',
  'ip.rows7': 'Rows updated in 7 days',
  'ip.lastSync': 'Last sync {at}',
  'ip.syncNow': 'Sync now',
  'ip.off': 'Off',
  'ip.enable': 'Enable sync for {v}',
  'ip.offLast': 'Off · last run {v}',
  'ip.spark': '{k}: {n} rows updated in 7 days ({h})',
  'ip.import': 'Import carrier file',
  'ip.importTip': 'Excel · CSV · multi-file ZIP · PDF / images via Ask HANA · services matched by carrier + service name',
  'ip.carrierSel': 'Carrier: {v}',
  'ip.carrier': 'Carrier',
  'ip.aiTip': 'Ask HANA reads Routing Network / Long Term Schedule images and PDFs · fills a draft only',
  'ip.aiBtn': 'Ask HANA reads image / PDF',
  'ip.pickFile': 'Choose carrier schedule file',
  'ip.rowsN': '{n} rows',
  'ip.byKind': 'Filter by change type',
  'ip.draft': 'Draft · {v}',
  'ip.preview': 'Preview rows',
  'ip.pickWrite': 'Select to write {v}',
  'ip.cancel': 'Cancel',
  'ip.confirm': 'Confirm writing {n} sailings',
  'ip.recon': 'Actual ↔ long-term schedule reconciliation',
  'ip.reconSrc': 'Source: carrier notices · carrier API · TblVesselData',
  'ip.reconFilter': 'Filter reconciliation',
  'ip.autoRule': 'ETD off by ≤ 1 day: written to the long-term schedule automatically, logged and undoable · more than 1 day, vessel or closing change: waits for Pricing approval',
  'ip.autoLabel': 'Auto-write ≤ 1 day',
  'ip.autoAria': 'Auto-write small differences',
  'ip.autoOff': 'Auto-write is off · every difference waits for approval',
  'ip.noDiff': 'No differences left',
  'ip.diffs': 'Schedule differences',
  'ip.change': '{f} {a} to {b}',
  'ip.undoAria': 'Undo auto-write {v}',
  'ip.undo': 'Undo',
  'ip.skipAria': 'Dismiss difference {v}',
  'ip.skip': 'Dismiss',
  'ip.notify': 'Notify Booking',
  'ip.approve': 'Approve',
  'ip.due': 'Running out of schedule',
  'ip.ended': 'Ended',
  'ip.soon': 'Ending soon',
  'ip.allCovered': 'All services have enough schedule',
  'ip.endedAfter': 'Schedule ended after {v}',
  'ip.until': 'Schedule until {v}',
  'ip.openSvc': 'Open service {v}',
  'ip.weeksLeft': '{c}: {n} weeks of long-term schedule left · until {v}',
  'ip.weeks': '{n} weeks',
  'ip.importFor': 'Import {a} schedule for {b}',
  'ip.recent': 'Recent imports',
});
